import React from 'react'
import * as yup from 'yup'
import DefaultLayout, {
  LayoutSpacingOptions,
} from '@src/components/DefaultLayout'
import { Formik } from 'formik'
import MilliplexLayout from './MilliplexLayout'
import { Container, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { SelectedKits } from './utils'

const useStyles = makeStyles((theme: Theme) => {
  return {
    milliplexContainer: {
      width: '100%',
      [theme.breakpoints.down('md')]: {
        width: '90%',
      },
      [theme.breakpoints.down('sm')]: {
        width: 'fit-content',
        height: 'fit-content',
      },
      padding: theme.spacing(0, 0),
    },
  }
})

export interface MilliplexFormValues {
  species: string
  researchAreas: string[]
  analytes: string[]
  assay: string
  plateType: string
  instrumentType: string[]
  selectedKits: SelectedKits
  previouslyViewed: string
}

const Milliplex = () => {
  const classes = useStyles()
  const validationSchema = yup.object().shape({
    species: yup.string().required('Required Field'),
    assay: yup.string().required('Required Field'),
    plateType: yup.string().required('Required Field'),
    instrumentType: yup.array().min(1, 'Required Field'),
    analytes: yup.array().min(1, 'Required Field'),
  })

  return (
    <DefaultLayout spacing={LayoutSpacingOptions.SM}>
      <Container className={classes.milliplexContainer} maxWidth={'xl'}>
        <Formik<MilliplexFormValues>
          initialValues={{
            species: '',
            researchAreas: [],
            analytes: [],
            assay: '',
            plateType: '',
            instrumentType: [],
            selectedKits: {},
            previouslyViewed: '',
          }}
          onSubmit={(values) => {
            console.info('submit', values)
          }}
          validationSchema={validationSchema}
        >
          <MilliplexLayout />
        </Formik>
      </Container>
    </DefaultLayout>
  )
}

export default Milliplex
